export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6509.ff3f0e8b.jpg";